<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Gg1FGx/tc-custom/9781634866637.jpg?1723404860894" alt="This image is the cover for the book High Noon in Sandbridge"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">High Noon in Sandbridge
      </h1>
      <p class="bookDescription body article font2">
        <p>Sequel to <i>Daybreak in Sandbridge</i><br/><br/>Life is pretty good for Scooter and Andy Stahl-Howard these days. The restaurant is doing well and they’re happy with their little family.<br/><br/>Then Scooter’s sister meets an untimely end, and Scooter and Andy are suddenly guardians to a niece they’ve only met a handful of times. Their attempts to make a home for the bereaved child are complicated by Andy's mother, Scooter’s ex-lover, and the man who claims to be Billie’s father.<br/><br/>But whatever her parentage, Billie is a Stahl through and through -- stubborn and hot-tempered and not remotely interested in making a life in the one place her mother had sworn never to return. Will she ever learn to call Dockside and Sandbridge home?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elizabeth L. Brooks, Lynn Townsend
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2caebec0